import React, { useEffect, useRef } from 'react';
import { useField } from 'formik';
import AutocompletePlaceInput, {
	AutocompletePlaceInputProps,
} from '@/components/ui/AutocompletePlaceInput/AutocompletePlaceInput.tsx';
import { get } from 'lodash';
import GooglePlaceData = App.Data.GooglePlaceData;

interface FormikAutocompletePlaceInputProps
	extends Omit<AutocompletePlaceInputProps, 'value' | 'onChange' | 'errorMessage' | 'onTouched'> {
	name: string;
	prefillValue?: GooglePlaceData;
}

const FormikAutocompletePlaceInput: React.FC<FormikAutocompletePlaceInputProps> = ({ name, prefillValue, ...props }) => {
	const [{ value }, { error, touched }, { setValue, setTouched }] = useField(name);
	const appliedPrefillKey = useRef<string | undefined>(undefined);
	const prefillKey = [prefillValue?.googlePlaceId, prefillValue?.name].filter(Boolean).join('|');
	const hasValue = !!(value?.googlePlaceId || value?.name);
	const shouldUsePrefill = !!prefillValue && !hasValue && appliedPrefillKey.current !== prefillKey;

	useEffect(() => {
		if (!shouldUsePrefill || !prefillKey) {
			return;
		}

		appliedPrefillKey.current = prefillKey;
		setValue(prefillValue, false);
	}, [prefillKey, prefillValue, setValue, shouldUsePrefill]);

	return (
		<AutocompletePlaceInput
			{...props}
			name={name}
			value={shouldUsePrefill ? prefillValue : value}
			onTouched={() => setTouched(true)}
			onChange={setValue}
			errorMessage={get(error, 'googlePlaceId', error)}
			touched={touched}
		/>
	);
};

export default FormikAutocompletePlaceInput;
